import { SET_NEW_USER_TOUR_HAS_COMPLETED } from '../actions/onboarding-actions-types'

const INITIAL_STATE_SET_NEW_USER_TOUR_HAS_COMPLETED = { isCompleted: '' }

export function setNewUserTourHasCompletedReducer(state = INITIAL_STATE_SET_NEW_USER_TOUR_HAS_COMPLETED, action) {
    switch (action.type) {
        case SET_NEW_USER_TOUR_HAS_COMPLETED:
            return { isCompleted: action.payload }
        default:
            return state;
    }
}